<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Şifre sıfırlama isteği</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="definitionForm">
    <div class="modal-body">

      <div class="form-group">
        <label>Kullanıcı adınız</label>
        <input type="text" formControlName="username" class="form-control">
      </div>
      
       
      
    </div>

    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Kaydet</button>
    </div>
  </form>
</div>